export default "__VITE_ASSET__bsewBKyJ__"